export type Book = {
  id: number;
  author?: string;
  authorId?: number;
  title: string;
  imgUrl: string;
  circleImgUrl: string;
  imagePath: string;
  circleImagePath: string;
  isPublished: boolean;
  description: string;
  translatorName: string;
  readerName: string;
  categoryIds: number[];
  publisherId: number | null;
  fileUrl?: string | null;
  categoryTitles?: string[];
  publisherTitle?: string | null;
};

export type SaveBook = Omit<Book, 'imagePath' | 'circleImagePath'>;

export type GetBooks = {
  books: Book[] | null;
  count: number;
  totalPages?: number;
  currentPage?: number;
  limit?: number;
  offset?: number;
};

export type GetBooksParams = {
  limit?: number;
  offset?: number;
  published?: boolean;
  searchQuery?: string;
};

export enum BookStatusTabEnum {
  All = 'all',
  Published = 'published',
  Draft = 'draft',
}

export enum LanguageEnum {
  RU = 'ru',
  ENG = 'en',
}

export type BookUploadImage = {
  imageUrl: string;
  imagePath: string;
};

export type GetBookCategories = {
  categories: BookCategories[];
};

export type BookCategories = {
  id: number;
  title: string;
  imgUrl: string;
  language: string;
};

export type GetBookAuthors = {
  authors: BookAuthors[];
};

export type BookAuthors = {
  id: number;
  name: string;
  description: string;
};

export enum BookImageType {
  MAIN = 'main',
  CIRCLE = 'circle',
}

export type GetBookPublishers = {
  publishers: BookPublishers[];
};

export type BookPublishers = {
  id: number;
  title: string;
  description: string;
  imgUrl: string;
  url: string;
  language: string;
};

export type BookLessons = {
  id?: number;
  lessonId?: number;
  bookId: number;
  title: string;
  description: string;
  audioUrl: string | null;
  index: number;
  duration: number;
};

export type GetBookLessons = {
  lessons: BookLessons[];
};

export type BookBatchLessons = {
  audio: File | null;
  timecodes: string;
  bookId: number | null;
};

export type BatchProcessStatus = {
  status: string;
  message: string;
};

export enum AudioProcessingStatus {
  WAITING = 'waiting',
  SUCCESS = 'success',
  ERROR = 'error',
  IDLE = 'idle',
  SPLITTED = 'splitted',
}
